// extracted by mini-css-extract-plugin
export default {"PhotoCropInput":"bft_a"};